import React, { useState } from 'react'
import { hashHistory } from 'react-router'
import { CircularProgress } from '@mui/material'
import { useStyle } from './style'
import * as requests from '../../../lib/requests.es6'

const CustomerRegister = ({ onBack }) => {
  const classes = useStyle()
  const [formData, setFormData] = useState({
    full_name: '',
    msisdn: '',
    email: '',
    id_number: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const checkCustomerReady = async customerGuid => {
    try {
      await requests.getCustomerRegistrationStatusByGuid(customerGuid)
      return true
    } catch (err) {
      return false
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')

    if (!formData.full_name || !formData.msisdn) {
      setError('Name and phone number are required')
      return
    }

    setLoading(true)
    try {
      let msisdn = formData.msisdn.trim()
      if (msisdn.startsWith('0')) {
        msisdn = msisdn.substring(1)
      }
      msisdn = '00254' + msisdn

      const response = await requests.registerCustomer({
        ...formData,
        msisdn: msisdn
      })
      const newCustomer = response.data.customer
      const registrationMessage = response.data.message
      const customerGuid = newCustomer && newCustomer.guid

      if (!customerGuid) {
        setError('Customer registered but could not retrieve customer GUID')
        setLoading(false)
        return
      }

      setError(`${registrationMessage}. Processing registration...`)
      let customerReady = false
      for (let attempt = 0; attempt < 10; attempt++) {
        await new Promise(resolve => setTimeout(resolve, 500))
        customerReady = await checkCustomerReady(customerGuid)
        if (customerReady) {
          break
        }
      }

      if (customerReady) {
        hashHistory.push(`admin/create-quote/${customerGuid}`)
      } else {
        setError(
          `${registrationMessage}. Please try navigating to policy creation manually if it doesn't proceed.`
        )
      }
    } catch (err) {
      const errorMessage =
        err && err.response && err.response.data && err.response.data.message
      setError(errorMessage || 'Error registering customer')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.formWrapper}>
      {onBack && (
        <button className={classes.backButton} onClick={onBack}>
          ← Back
        </button>
      )}
      <h2 className={classes.formTitle}>Register New Customer</h2>

      <form onSubmit={handleSubmit}>
        <div className={classes.formGroup}>
          <label className={classes.label}>Full Name *</label>
          <input
            type="text"
            name="full_name"
            className={classes.input}
            placeholder="Enter customer name"
            value={formData.full_name}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className={classes.formGroup}>
          <label className={classes.label}>Phone Number *</label>
          <input
            type="tel"
            name="msisdn"
            className={classes.input}
            placeholder="Enter phone number"
            value={formData.msisdn}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className={classes.formGroup}>
          <label className={classes.label}>Email</label>
          <input
            type="email"
            name="email"
            className={classes.input}
            placeholder="Enter email address"
            value={formData.email}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className={classes.formGroup}>
          <label className={classes.label}>ID Number</label>
          <input
            type="text"
            name="id_number"
            className={classes.input}
            placeholder="Enter ID number"
            value={formData.id_number}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        {error && <div className={classes.error} style={{ marginBottom: '16px' }}>{error}</div>}

        <button
          type="submit"
          className={classes.submitButton}
          disabled={loading}
          style={{
            opacity: loading ? 0.6 : 1,
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} style={{ marginRight: '10px' }} />
              Registering...
            </>
          ) : (
            'Register and Continue'
          )}
        </button>
      </form>
    </div>
  )
}

export default CustomerRegister
